module.exports = __webpack_public_path__ + "static/media/pay.9bec42f5.svg";